// Manages state for promo modal's for vanity URLs
// These are generally onboarding promos to drive signup, and then immediately after to drive behavior

import React, { createContext, useContext, useEffect, useState } from 'react'

import { useAppContext } from '~/src/context/AppProvider'
// import useExtensionState from '~/src/hooks/useExtensionState'
import { VANITY_URL_PROMOS } from '~/src/lib/vanityUrlPromos'

interface IPromoModalContext {
  loading: boolean
  promoData: (typeof VANITY_URL_PROMOS)[number] | null
  showModal: boolean
  setShowModal: (show: boolean) => void
}

const defaultContext = {
  loading: true,
  promoData: null,
  showModal: false,
  setShowModal: () => {},
}

// Create the context
const PromoModalContext = createContext<IPromoModalContext>(defaultContext)

// Custom hook to access the context
export const usePromoModalProvider = () => {
  const context = useContext(PromoModalContext)
  if (!context) {
    throw new Error(
      'usePromoModalProvider must be used within a <PromoModalProvider> component'
    )
  }
  return context
}

// Provider component
const PromoModalProvider: React.FC<
  React.PropsWithChildren<{
    promoData: (typeof VANITY_URL_PROMOS)[number] | null
  }>
> = ({ children, promoData }) => {
  const { authUser, loadingAuthUser } = useAppContext()
  const [showModal, setShowModal] = useState(false)
  // const { loading: loadingExtension } = useExtensionState()

  const loading = !!loadingAuthUser // || loadingExtension

  useEffect(() => {
    if (loading) return
    if (!promoData?.code) return
    // if (authUser?.uid) return

    setShowModal(true)
  }, [loading, promoData?.code, setShowModal, authUser?.uid])

  return (
    <PromoModalContext.Provider
      value={{
        loading,
        promoData,
        showModal,
        setShowModal,
      }}
    >
      {children}
    </PromoModalContext.Provider>
  )
}

export default PromoModalProvider
